import {Injectable} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {ErrorService} from '../services/error.service';
import {SuccessConfirmation} from '../types/base';
import {FileInfoData, FileInfoResponse, FileInfosResponse} from '../types/file';

const uploadOptions = { headers: new HttpHeaders(), observe: 'events' as const, reportProgress: true };


@Injectable({
    providedIn: 'root',
})
export class FileHttpService {
    constructor(private http: HttpClient, private errorService: ErrorService) { }

    getFileInfo(attraction_id: string, file_id: string): Observable<FileInfoResponse> {
        return this.http.get<FileInfoResponse>(`attractions/${attraction_id}/files/${file_id}`).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
    }

    getAllFileInfos(attraction_id: string): Observable<FileInfosResponse> {
        return this.http.get<FileInfosResponse>(`attractions/${attraction_id}/files/`).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
    }

    createFile(attraction_id: string, file: File, info: FileInfoData): Observable<HttpEvent<FileInfoResponse>> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', info.name);
        formData.append('desciption', info.description);
        //formData.append('parent', info.parent_id);
        //formData.append('attraction', info.attraction_id);
        formData.append('index', info.index.toString());
        return <Observable<HttpEvent<FileInfoResponse>>>this.http.post<FileInfoResponse>(`attractions/${attraction_id}/files/`, formData, uploadOptions).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
    }

  uploadArchive(attraction_id: string, unit_id: string, file: File, info: FileInfoData): Observable<HttpEvent<FileInfoResponse>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', info.name);
    //formData.append('unit', info.parent_id);
    //formData.append('attraction', info.attraction_id);
    return <Observable<HttpEvent<FileInfoResponse>>>this.http.post<FileInfoResponse>(`attractions/${attraction_id}/files/archive/upload/${unit_id}`, formData, uploadOptions).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
  }

    updateFileInfo(attraction_id: string, file_id: string, file: FileInfoData): Observable<FileInfoResponse> {
        return this.http.put<FileInfoResponse>(`attractions/${attraction_id}/files/${file_id}`, file).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
    }

    deleteFile(attraction_id: string, file_id: string): Observable<SuccessConfirmation> {
        return this.http.delete<SuccessConfirmation>(`attractions/${attraction_id}/files/${file_id}`).pipe(catchError((err, caught) => this.errorService.handleError(err, caught)));
    }


}
